import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing Supabase config. Copy .env.example to .env and fill in VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY."
  );
}

// The anon key is public by design (it ships to the browser). Database access
// must be constrained server-side via Row Level Security — see SUPABASE_SECURITY.md.
export const supabase = createClient(url, anonKey);
